// Helpers for showing a soft-deleted cart item in the table "Items" modal (no React, no network,
// so they can be unit tested with `node --test`). The server keeps an item that was deleted after
// the order was sent to the kitchen: it stays on the order with a `deleted_at` time, which the
// table-items API returns as `item_deleted` (null/absent for a live item).

/** True when the API row (item or deal) has been deleted. */
export const isDeletedItem = (row) => !!(row && row.item_deleted);

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/**
 * "2026-10-07 12:05:51" -> "12:05 PM" when it is the same calendar day as `now`, otherwise
 * "6 Oct, 5:49 PM". Empty string when the value cannot be read (the label then just says "Deleted").
 */
export const formatDeletedAt = (value, now = new Date()) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(String(value || ""));
  if (!m) return "";
  const [year, month, day, hour, minute] = [+m[1], +m[2], +m[3], +m[4], +m[5]];
  if (month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59) return "";

  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  const time = `${hour12}:${String(minute).padStart(2, "0")} ${hour < 12 ? "AM" : "PM"}`;
  const sameDay = now.getFullYear() === year && now.getMonth() + 1 === month && now.getDate() === day;

  return sameDay ? time : `${day} ${MONTHS[month - 1]}, ${time}`;
};

/** Text of the red label next to a deleted item: "Deleted 12:05 PM" or just "Deleted". */
export const deletedLabel = (value, now = new Date()) => {
  const when = formatDeletedAt(value, now);
  return when ? `Deleted ${when}` : "Deleted";
};
